import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import Footer from "../ones/Footer";
import ContactUsContent from "../ones/ContactUsContent";
import PageWithSidebar from "../components/PageWithSidebar";
import PageHero from "../ones/PageHero";
import ContactBgImg from "../assets/image16.jpeg";

export default function View(props) {
  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..

    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <>
        <PageHero
          bgImage={ContactBgImg}
          kicker="Contact Us"
          heading="Anuani na Mawasiliano"
          paragraph="Wasiliana nasi kwa maswali, maoni, au kufika moja kwa moja katika ofisi zetu"
        />
        <PageWithSidebar>
          <ContactUsContent />
        </PageWithSidebar>
        <Footer />
      </>
    );
  } else {
    return <div className="container mSupportLoading">{getInlineLoader()}</div>;
  }
}
